import enums from "./../enums";

export default (
	state = {
		unauthError: false,
		config: {},
		captchaCheck: false,
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.SET_CONFIG:
			return {
				...state,
				config: payload,
				captchaCheck: payload?.enableCaptcha ?? false,
			};
		case enums.UNAUTH_ERROR:
			return { ...state, unauthError: payload };
		default:
			return state;
	}
};
